// Configuration for Free Image Upload Services
const CONFIG = {
  // Option 1: ImgBB (Easiest to set up)
  // Go to https://api.imgbb.com/ to get your free API key
  imgbbApiKey: "ab270d8aaaae334ea6c3e6587a35657c",

  // Option 2: Cloudinary (Advanced features, fast CDN)
  // Go to https://cloudinary.com/ to get your Cloud Name and create an Unsigned Upload Preset in Settings
  cloudinaryCloudName: "",
  cloudinaryUploadPreset: "",
};

/**
 * Uploads an image file to the configured free service.
 * @param {File} file - The file object to upload.
 * @returns {Promise<string>} The download URL of the uploaded image.
 */
export const uploadImage = async (file) => {
  if (!file) {
    throw new Error("No file provided for upload");
  }

  // 1. Check Cloudinary first if configured
  if (CONFIG.cloudinaryCloudName && CONFIG.cloudinaryUploadPreset) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", CONFIG.cloudinaryUploadPreset);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CONFIG.cloudinaryCloudName}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error?.message || "Failed to upload image to Cloudinary");
    }

    const data = await response.json();
    return data.secure_url || data.url;
  }

  // 2. Check ImgBB if configured
  if (CONFIG.imgbbApiKey) {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(
      `https://api.imgbb.com/1/upload?key=${CONFIG.imgbbApiKey}`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error?.message || "Failed to upload image to ImgBB");
    }

    const data = await response.json();
    return data.data.url;
  }

  // 3. Neither configured
  const errorMsg = "No free image upload service configured in src/utils/imageUpload.js. Please provide an ImgBB API key or Cloudinary credentials.";
  console.error(errorMsg);
  
  // We'll throw an error so the user gets notified in the UI via the catch blocks.
  throw new Error(errorMsg);
};

/**
 * Dummy function for deleting images.
 * Unsigned client-side deletions are not supported directly without API secrets/signatures.
 * Returns a resolved Promise to keep deletion flows from breaking.
 */
export const deleteImage = async (url) => {
  console.log("Delete called for URL (ignored on free client upload):", url);
  return Promise.resolve();
};
